import {
  ShoppingCartContext,
  ShoppingCartErrorSetterContext,
  SideCartContext,
} from '@context/shoppingCart';
import { useContext } from 'react';
import invariant from 'tiny-invariant';

export const useShoppingCart = () => useContext(ShoppingCartContext);
export const useSideCart = () => useContext(SideCartContext);
export const useShoppingCartErrorSetter = () => {
  const ctx = useContext(ShoppingCartErrorSetterContext);

  invariant(
    ctx,
    'ShoppingCartErrorContext should be prevent upper in the tree',
  );

  return ctx;
};
